import { graphql } from '../../../gql';

/**
 * TRIL-221: client GQL op for the server's existing refreshAuthToken
 * mutation. AuthTokens shape is { accessToken, refreshToken } — the
 * server rotates BOTH on each successful refresh (the old refresh
 * token is deleted from RefreshTokensTable), so consumers must write
 * the new pair atomically before flipping isSignedIn.
 *
 * Server resolver: server/src/resolvers/userMutations/mutations/refreshToken.mutation.ts
 * Server typedef:  server/src/typeDefs/user.gql.ts:18
 */
export const REFRESH_AUTH_TOKEN_MUTATION = graphql(`
  mutation refreshAuthToken($refreshToken: String!) {
    refreshAuthToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      sessionId
    }
  }
`);
